module.exports = __webpack_public_path__ + "img/w3_trash_grey.4b1c6720.png";